import React, { useState, useEffect, useRef } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import "./App.css";
import "../src/styles/tailwind.css";
import Home from "./containers/Home/home";
import Service from "./containers/Service/service";
import Blog from "./containers/Blog/blog";
import AboutUS from "./containers/Page/AboutUs";
import Loader from "./components/Loader";
import Navbar from "./components/Navbar";
import HeaderSection from "./components/HeaderSection";
import Footer from "./components/Footer";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ScrollToTop from "./components/ScrollToTop";
import AppoinmentModal from "./components/AppoinmnetModal";
import Consult from "./containers/Consult/Consult";
import Contact from "./containers/Contact/Contact";
import CaseStudy from "./components/CaseStudy";
import PrivacyPolicy from "./components/PrivacyPolicy";
import RefundPolicy from "./components/RefundPolicy";
import TermsCondition from "./components/Terms&Condition";
import BlogDetails from "./components/BlogDetails";
import Courses from "./containers/Courses/Courses";
import CoursesDetails from "./containers/CoursesDetails/CoursesDetails";
import Login from "./containers/Login/Login";
import Cart from "./containers/Cart/Cart";
import DashboardOverview from "./components/DashboardLayouts/DashboardOverview";

// Create a wrapper component to use useLocation hook
const AppContent = () => {
  const location = useLocation();
  const [loading, setLoading] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const appointmentRef = useRef(null);

  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 1000);
  }, []);

  const scrollToAppointment = () => {
    if (appointmentRef.current) {
      appointmentRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  // Check if current path is dashboard
  const isDashboard = location.pathname === "/dashboard";

  return (
    <>
      <ScrollToTop />
      
      {/* Conditionally render HeaderSection and Navbar - hide on dashboard */}
      {!isDashboard && (
        <>
          <HeaderSection
            onAppointmentClick={scrollToAppointment}
            openModal={openModal}
          />
          <Navbar />
        </>
      )}

      {loading ? (
        <Loader
          size={12}
          margin={4}
          color="#6dbe45"
          loading={loading}
          cssOverride={{ backgroundColor: "#f0f0f0" }}
          speedMultiplier={2}
          width="auto"
        />
      ) : (
        <Routes>
          <Route path="/" element={<Home appointmentRef={appointmentRef} />} />
          <Route path="/about-us" element={<AboutUS appointmentRef={appointmentRef} />} />
          <Route path="/service" element={<Service />} />
          <Route path="/consult" element={<Consult />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/case-study" element={<CaseStudy />} />
          <Route path="/blog/:id" element={<BlogDetails />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-conditions" element={<TermsCondition />} />
          <Route path="/refund-policy" element={<RefundPolicy />} />
          <Route path="/courses" element={<Courses />} />
          <Route path="/courses-details/:slug" element={<CoursesDetails />} />
          <Route path="/login" element={<Login />} />
          <Route path="/cart" element={<Cart />} />
          {/* <Route path="/dashboard" element={<DashboardOverview />} /> */}
          
          <Route path="*" element={<Home />} />
        </Routes>
      )}

      {/* Conditionally render Footer - hide on dashboard */}
      {!isDashboard && <Footer />}

      {isModalOpen && <AppoinmentModal isOpen={isModalOpen} onClose={closeModal} />}
    </>
  );
};

function App() {
  return (
    <div className="min-h-screen">
      <ToastContainer />
      <BrowserRouter>
        <AppContent />
      </BrowserRouter>
    </div>
  );
}

export default App;